export const useLoadingPage = () => {
  const openLoadingPage = (target: string = "_blank") => {
    return window.open(`${window.location.origin}/loading`, target);
  };

  return {
    openLoadingPage,
  };
};
